import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SearchFormComponent } from './search-form.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';

const PRIMENG_MODULES = [
  AccordionModule,
  ButtonModule
];

@NgModule({
  declarations: [
    SearchFormComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    ...PRIMENG_MODULES
  ],
  exports: [
    SearchFormComponent
  ]
})
export class SearchFormModule { }
